
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/government",
      function () {
        return require("private-next-pages/use-cases/government.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/government"])
      });
    }
  